import { render, staticRenderFns } from "./LowerCode.vue?vue&type=template&id=458292d4&"
import script from "./LowerCode.vue?vue&type=script&lang=js&"
export * from "./LowerCode.vue?vue&type=script&lang=js&"
import style0 from "./LowerCode.vue?vue&type=style&index=0&id=458292d4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports